import { Circle } from 'lucide-react';
import { Button } from '../button/button.tsx';
import { Spinner } from '../spinner/spinner.tsx';
import type { ChatComposerDictation } from './chat-composer-types.ts';
import { dictationClock } from './dictationClock.ts';

interface ChatComposerRecordingProps {
  /** A dictation that is recording or sending, never one standing idle. */
  listening: ChatComposerDictation;
  /** On the quiet link that throws the recording away. */
  cancelLabel: string;
}

/** What stands in the pill instead of the field while the composer is a recorder. */
export function ChatComposerRecording({
  listening,
  cancelLabel,
}: ChatComposerRecordingProps) {
  const transcribing = listening.state === 'sending';

  return (
    <div
      data-slot='chat-composer-recording'
      className='flex min-w-0 flex-1 items-center gap-2.5'
    >
      {/*
        The filled red dot every device in the room uses for this, beating
        while the microphone is open — and, once the recording is on its
        way to be read, the ring that says the waiting is ours now.
      */}
      {transcribing ? (
        <Spinner className='text-ink-muted' />
      ) : (
        <Circle
          aria-hidden='true'
          className='size-2.5 shrink-0 animate-pulse fill-danger text-danger'
        />
      )}
      <span className='text-base text-ink-secondary tabular-nums'>
        {dictationClock(listening.seconds)}
      </span>
      {/*
        Quiet, and in words. A cross beside a clock reads as the way out
        of the recording to anyone in a hurry, which is how a finished
        sentence ends up in the bin instead of in the conversation.
      */}
      {transcribing ? null : (
        <Button variant='link' size='sm' onClick={listening.onCancel}>
          {cancelLabel}
        </Button>
      )}
    </div>
  );
}
